"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CARTS_PATH = 'carts';
/**
 * This class is used for CRUD operations for NIF eCommerce API.
 */

var NifCartService = /*#__PURE__*/function (_AbstractService) {
  _inherits(NifCartService, _AbstractService);

  var _super = _createSuper(NifCartService);

  function NifCartService() {
    _classCallCheck(this, NifCartService);

    return _super.apply(this, arguments);
  }

  _createClass(NifCartService, [{
    key: "getCarts",

    /**
     * Fetches all carts, returns empty array if 0 (zero) carts.
     *
     * @param {object} config Configuration.
     * @param {object[]} config.items Array of retail item objects.
     * @returns {Promise} Promise object.
     */
    value: function getCarts(config) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        fetch("".concat(config.endpoints.nifECommerceApiEndpoint, "/").concat(CARTS_PATH), {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json'
          }
        }).then(_this._handleJsonResponse.bind(_this)).then(function (carts) {
          return _this._parseResponse(carts);
        }).then(function (carts) {
          return resolve(carts);
        }).catch(_this._rejectWrapper.bind(_this, reject));
      });
    }
    /**
     * Creates a cart and returns the id.
     *
     * @param {object} config Configuration.
     * @param {object[]} config.endpoints Endpoints for API.
     * @param {object[]} config.countryCode Country code.
     * @param {object[]} config.languageCode Language code.
     * @param {object[]} config.retailUnitType [config.retailUnitType=ru] The type of unit (ru = Retail Unit/Market or sto = Store).
     * @returns {Promise} Promise object.
     */

  }, {
    key: "createCart",
    value: function createCart(config) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        config.retailUnitType = config.retailUnitType || 'ru';

        if (!(config.retailUnitType === 'sto' || config.retailUnitType === 'ru')) {
          throw new _ServiceException.default('Wrong retailUnitType. Please use: ru = Retail Unit/Market or sto = Store', _this2.constructor.factoryName);
        }

        fetch("".concat(config.endpoints.nifECommerceApiEndpoint, "/").concat(CARTS_PATH), {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            context: {
              id: config.retailUnit,
              type: config.retailUnitType
            },
            countryCode: config.retailUnit,
            languageCode: config.languageCode
          })
        }).then(function (response) {
          return response.json();
        }).then(function (responseCart) {
          return resolve(_this2._parseResponseCart(responseCart));
        }).catch(_this2._rejectWrapper.bind(_this2, reject));
      });
    }
    /**
     * Add cart items to cart.
     *
     * @param {object} config Configuration.
     * @param {object[]} config.endpoints Endpoints for API.
     * @param {object[]} config.items Array of retail item objects.
     * @param {string} cartId Cart id.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "addCartItems",
    value: function addCartItems(config, cartId) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var url = "".concat(config.endpoints.nifECommerceApiEndpoint, "/").concat(CARTS_PATH, "/").concat(cartId, "/items");
        fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: _this3._createCartItems(config.items)
          })
        }).then(_this3._handleResponse.bind(_this3)).then(function () {
          //TODO: Anything more that needs to be done here?
          _this3.getCartCount(config, cartId).then(function (cartCount) {
            resolve({
              ErrorList: [],
              CartCount: cartCount
            });
          }).catch(_this3._rejectWrapper.bind(_this3, reject));
        }).catch(_this3._rejectWrapper.bind(_this3, reject));
      });
    }
    /**
     * Fetches and returns the cart count.
     *
     * @param {object} config Configuration.
     * @param {object[]} config.cartId Cart id.
     * @param {object[]} config.endpoints Endpoints for API.
     * @param {string} cartId Cart id.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getCartCount",
    value: function getCartCount(config, cartId) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        fetch("".concat(config.endpoints.nifECommerceApiEndpoint, "/").concat(CARTS_PATH, "/").concat(cartId), {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          return resolve(response.quantity);
        }).catch(_this4._rejectWrapper.bind(_this4, reject));
      });
    }
    /**
     * Creates cart items from retail item objects.
     *
     * @param {object[]} items Array of retail item objects.
     * @returns {Array} Item array.
     */

  }, {
    key: "_createCartItems",
    value: function _createCartItems(items) {
      var cartItems = [];

      var _iterator = _createForOfIteratorHelper(items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (typeof item.id !== 'string' || typeof item.type !== 'string' || typeof item.qty !== 'number') {
            throw new _ServiceException.default('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", qty: 1 }', this.constructor.factoryName);
          }

          cartItems.push({
            itemNo: item.id,
            type: item.type,
            quantity: item.qty
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return cartItems;
    }
    /**
     * Parses and validates get carts response.
     *
     * @param {object} carts Carts response.
     * @returns {object[]} Valid carts.
     */

  }, {
    key: "_parseResponse",
    value: function _parseResponse(carts) {
      var _this5 = this;

      return carts.map(function (cart) {
        return _this5._parseResponseCart(cart);
      });
    }
    /**
     * Parses and validates cart response .
     *
     * @param {object} response Response containing the cart response.
     * @returns {object} Valid cart.
     */

  }, {
    key: "_parseResponseCart",
    value: function _parseResponseCart(response) {
      if (!response || !response.id) {
        throw new _ServiceException.default('Missing cart id in response.', this.constructor.factoryName);
      }

      return {
        id: response.id
      };
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'nifcart';
    }
  }]);

  return NifCartService;
}(_AbstractService2.default);

exports.default = NifCartService;